module.exports = __webpack_public_path__ + "media/configurations/SV_P-X-891cdb00.png";